import ForgetPassword from "./ForgetPassword.view";

export default ForgetPassword;
